import styles from "./ProgressBar.styles.scss";

const ProgressBar = ({value = 0, max = 100}) => {
  return <div className={styles.container}>
    <div className={styles.bar} style={{width: (value / max * 100) + "%"}} />
  </div>;
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./components/ProgressBar/ProgressBar.js